import { getDiagramCanvasBackground } from "../../styles";

// Estilos do preview read-only de template
const styles = (theme) => ({
  // Área fixa com altura para o React Flow conseguir medir e renderizar
  previewBox: {
    position: "relative",
    flex: 1,
    minHeight: 0,
    width: "100%",
    borderRadius: 2,
    overflow: "hidden",
    border: `1px solid ${theme?.palette?.divider}`,
    backgroundColor: getDiagramCanvasBackground(theme),
  },
});

export default styles;
